import { StringSchema } from 'yup';
import moment from 'moment';

export default function birthdayDate(
  this: StringSchema,
  message = 'Data inválida'
) {
  return this.test('birthdayDate', message, (value) => {
    if (!value) return true;

    if (!/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/.test(value)) {
      return false;
    }

    const date = moment(value, 'DD/MM/YYYY');
    return date.isValid() && date.isBefore(moment());
  });
}
